import {
    QueryDatasetDocument,
    useRunExportJobMutation,
} from '@warebee/frontend/data-access-api-graphql';
import {
    DatasetQueryConverterConfig,
    DatasetQueryExportJobParams,
} from '@warebee/shared/export-converter';
import { CompiledQuery } from 'kysely';
import { useRecoilCallback, useRecoilValue } from 'recoil';
import { warehouseSelectedId } from '../store/warehouse.state';

export type ExportDatasetQueryParams = {
  query: CompiledQuery<any>;
  converterConfig: DatasetQueryConverterConfig<any>;
  filename: string;
};

function useExportDatasetQuery() {
  const warehouseId = useRecoilValue(warehouseSelectedId);
  const [runExportCSV] = useRunExportJobMutation();

  const exportCallback = useRecoilCallback(
    ({ snapshot }) =>
      async (params: ExportDatasetQueryParams) => {
        const variables: DatasetQueryExportJobParams<any> = {
          converterId: 'DATASET_QUERY',
          query: QueryDatasetDocument.loc.source.body,
          config: params.converterConfig,
          variables: {
            warehouseId: warehouseId,
            query: params.query.sql,
            params: params.query.parameters,
          },
          filename: `${params.filename}.csv`,
        };

        const { data, errors } = await runExportCSV({
          variables,
        });

        return {
          errors: errors,
          job: data.createExportJob,
        };
      },
  );

  return exportCallback;
}
export default useExportDatasetQuery;
